import { SxProps, useColorScheme } from "@mui/material";

import { MoonIcon, SunIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { IconSwitch } from "components/IconSwitch/IconSwitch";

type ThemeSwitchProps = {
  sx?: SxProps;
};

export function ThemeSwitch({ sx }: ThemeSwitchProps) {
  const { t } = useTranslation();
  const { mode, setMode } = useColorScheme();

  return (
    <IconSwitch
      checked={mode === "light"}
      onChange={(checked) => setMode(checked ? "light" : "dark")}
      onIcon={<SunIcon />}
      offIcon={<MoonIcon />}
      sx={sx}
      label={t("Select mode")}
    />
  );
}
